import { render, staticRenderFns } from "./ExperimentDetails.vue?vue&type=template&id=cc5c93b0&scoped=true&"
import script from "./ExperimentDetails.vue?vue&type=script&lang=js&"
export * from "./ExperimentDetails.vue?vue&type=script&lang=js&"
import style0 from "./ExperimentDetails.vue?vue&type=style&index=0&id=cc5c93b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc5c93b0",
  null
  
)

export default component.exports